import { amb, cnxAPI, cnxSeg, notifica, show_ldr, getIdUsuario } from "./utils"
import axios from "axios"

var a = null

//Función que valida usuario y contraseña
function authUser() {
  var us = document.getElementById("inp_us").value,
    ps = document.getElementById("inp_ps").value,
    ob = { user: us, password: ps, idAplicacion: 39, idOrigen: 1 }
  let dats = btoa(unescape(encodeURIComponent(JSON.stringify(ob))))

  axios({
    method: "post",
    url: cnxSeg + "login/validar",
    data: "data=" + dats,
  })
    .then(function (response) {
      if (response.data.code !== 200) {
        show_ldr(false)
        notifica("warning", response.data.message, "Alerta!")
      } else {
        getAmbientes(response.data.data[0])
      }
    })
    .catch(function (error) {
      notifica("warning", error, "Alerta!")
      show_ldr(false)
    })
}

//Función que obtiene ambientes disponibles
function getAmbientes(resp) {
  var apps = resp.aplicaciones.find((x) => x.idAplicacion === "39"),
    obj = {
      idUsuarioAct: resp.idUsuario,
      idAplicacion: apps.idAplicacion,
      token: resp.token,
    }
  let dats = btoa(unescape(encodeURIComponent(JSON.stringify(obj))))
  axios({
    method: "post",
    url: cnxSeg + "login/ambientes",
    data: "data=" + dats,
  })
    .then(function (response) {
      if (response.data.code !== 200) {
        show_ldr(false)
        notifica("warning", response.data.message, "Alerta!")
      } else {
        var ambs = response.data.data.find((x) => x.idAmbiente === "1"),
          dt = {
            idUsuario: resp.idUsuario,
            nombre: resp.nombre + " " + resp.aP,
            tkn: resp.token,
          },
          as = {
            idUsuarioAct: resp.idUsuario,
            idAmbiente: ambs.idAmbiente,
            token: resp.token,
          }
        finLogin(dt, as)
      }
    })
    .catch(function (error) {
      notifica("warning", error, "Alerta!")
      show_ldr(false)
    })
}

//Función que finaliza proceso de login seleccionando ambiente
function finLogin(dt, as) {
  let dats = btoa(unescape(encodeURIComponent(JSON.stringify(as)))),
    dtUs = btoa(unescape(encodeURIComponent(JSON.stringify(dt))))

  axios({
    method: "post",
    url: cnxSeg + "login/ambSelect",
    data: "data=" + dats,
  }).then(function (response) {
    if (response.data.code === 200) {
      localStorage.setItem(`${amb}_login`, 1)
      sessionStorage.setItem(amb + "UD", dtUs)
      window.location = "/user/"
    } else {
      show_ldr(false)
      notifica("warning", response.data.message, "Alerta!")
    }
  })
}

function getMenu(_callback) {
  show_ldr(true)
  axios({
    method: "post",
    url: `${cnxAPI}Auth/GetMenu`,
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      "X-Requested-With": "XMLHttpRequest",
    },
    data: { IdUsuario: getIdUsuario() },
  })
    .then(function (response) {
      show_ldr(false)
      if (response.status !== 200) {
        notifica("warning", response.data.message, "Alerta!")
      } else {
        a = response.data
      }
    })
    .catch(function (error) {
      show_ldr(false)
      notifica("danger", error, "Error")
    })
    .then(() => _callback(a))
}

export { authUser, getMenu }
